import './InfoBubble.scss';
import React from 'react';
import { Button } from 'primereact/button';


class InfoBubble extends React.Component {
  render() {
    return (
      <div className='InfoBubble'>
        <i className='pi pi-info-circle' />
        <Button
            label=''
            icon='pi'
            tooltip={this.props.text}
            tooltipOptions={{
              className: 'InfoBubble-tooltip',
            }} />
      </div>
    );
  }
}


export default InfoBubble;
